import './Footer.css'

const Footer = () => {
  return (
      <footer>
          <p>Designed and created by <a href='https://www.linkedin.com/in/laurenleighcolvin/' target='_blank'>Lauren Colvin.</a></p>
      </footer>
  );
};

export default Footer;